import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { AdminAuthGuard } from "@/components/admin/AdminAuthGuard";
import { Admin2faSetupGate } from "@/components/admin/Admin2faSetupGate";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { AdminLoginPage } from "@/components/admin/AdminLoginPage";
import { AdminMustChangePasswordGate } from "@/components/admin/AdminMustChangePasswordGate";
import { isAdminPortalPath, isAdminPublicPath, adminPath } from "@/lib/adminRoute";
import { ensureAdminI18n } from "@/lib/i18next";
import { ADMIN_LANGUAGE_STORAGE_KEY, readStoredLanguage } from "@/lib/languageStorage";

export const Route = createFileRoute("/pulse-ops-x7k2")({
  head: () => ({
    meta: [{ title: "Pulse Admin" }],
  }),
  beforeLoad: async () => {
    await ensureAdminI18n(readStoredLanguage(ADMIN_LANGUAGE_STORAGE_KEY));
  },
  component: AdminShell,
});

function AdminShell() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isPublicArea = isAdminPublicPath(pathname);
  const isPortalArea = isAdminPortalPath(pathname);

  if (isPublicArea) {
    return <Outlet />;
  }

  if (isPortalArea) {
    const isSetup2fa = pathname === adminPath("setup-2fa");
    return (
      <AdminAuthGuard>
        <Admin2faSetupGate>
          {isSetup2fa ? (
            <Outlet />
          ) : (
            <AdminMustChangePasswordGate>
              <AdminLayout>
                <Outlet />
              </AdminLayout>
            </AdminMustChangePasswordGate>
          )}
        </Admin2faSetupGate>
      </AdminAuthGuard>
    );
  }

  return <AdminLoginPage />;
}
